import { Collapse, Form, Input, Button, message } from "antd";
import { useCallback, useEffect, useState } from "react";
import { useAuth } from "../../../../uiComponent/authProvider/AuthContext";
import {
  OutletSearchContent,
  OutletSearchRequest,
} from "../../../../services/dto/outlet";
import { Action } from "../../../../common/enum";
import OutletService, {
  OutletServiceAction,
} from "../../../../services/outletService";

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 14 },
  },
};

const { Panel } = Collapse;

interface SearchFilterProps {
  setData: React.Dispatch<React.SetStateAction<OutletSearchContent[]>>;
  initSearch?: boolean;
}

export default function SearchFilter({
  initSearch,
  setData,
}: SearchFilterProps) {
  const [form] = Form.useForm();
  const [initSearchFlag, setInitSearchFlag] = useState<boolean>(
    initSearch || false
  );
  const [filterCode, setFilterCode] = useState("");
  const [filterName, setFilterName] = useState("");
  const [loading, setLoading] = useState(false);
  const { loginData } = useAuth();

  const onSearch = useCallback(async () => {
    if (!loginData?._csrf) {
      return;
    }
    setLoading(true);
    try {
      const request: OutletSearchRequest = {
        code: filterCode || "",
        name: filterName || "",
        action: Action.DETAIL,
        loginId: loginData?.loginUsername || "",
      };

      const response = await OutletService(
        OutletServiceAction.SEARCH,
        request,
        loginData?._csrf
      );
      const data = await response;
      if (data?.result) {
        setData(data.result);
      } else {
        setData([]);
      }
    } catch (error) {
      message.error("Failed to fetch data. Please try again.");
    } finally {
      setLoading(false);
    }
  }, [filterCode, filterName, setData, loginData]);

  useEffect(() => {
    if (initSearchFlag === true) {
      onSearch();
      setInitSearchFlag(false);
    }
  }, [initSearchFlag, setInitSearchFlag, onSearch]);

  const onClean = () => {
    form.resetFields();
    setFilterName("");
    setFilterCode("");
    setData([]);
  };

  return (
    <Collapse defaultActiveKey={"1"}>
      <Panel header="Filter" key="1">
        <Form
          form={form}
          layout="horizontal"
          labelAlign={"left"}
          style={{ maxWidth: 600 }}
          {...formItemLayout}
        >
          <Form.Item label="Nama" name="name">
            <Input
              placeholder="Input Nama"
              value={filterName}
              onChange={(e) => setFilterName(e.target.value)}
            />
          </Form.Item>
          <Form.Item label="Kode" name="code">
            <Input
              placeholder="Input Kode"
              value={filterCode}
              onChange={(e) => setFilterCode(e.target.value)}
            />
          </Form.Item>
          <Form.Item wrapperCol={{ offset: 0, span: 24 }}>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                gap: "10px",
              }}
            >
              <Button type="primary" onClick={onSearch} loading={loading}>
                Search
              </Button>
              <Button onClick={onClean} disabled={loading}>
                Clear
              </Button>
            </div>
          </Form.Item>
        </Form>
      </Panel>
    </Collapse>
  );
}
